module.exports = __webpack_public_path__ + "img/knowing.bf22cce6.svg";